import { Component, OnDestroy, OnInit } from '@angular/core';
import { StateComponent } from '../state-component.interface';
import { Usdm2Service } from '../../../../services/ai/usdm2.service';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

type HighLevelDisgn = {
  study_type: string;
  phase_type: string;
  trial_type: string[];
};

@Component({
  selector: 'app-properties',
  imports: [],
  templateUrl: './properties.component.html',
  styleUrl: './properties.component.css',
})
export class PropertiesComponent implements StateComponent, OnInit, OnDestroy {
  stateName = 'Properties';
  private usdmSub: Subscription | null = null;
  data: HighLevelDisgn | null = null;
  studyType: string = '';
  phaseType: string = '';
  trialType: string[] = [];

  constructor(
    private usdm: Usdm2Service,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.usdmSub = this.usdm.contentUpdate$.subscribe((item) => {
      if (this.usdm.currentState() == this.stateName && item && item.type === 'FinishResponse') {
        this.data = item.result as HighLevelDisgn;
        this.extractProperties();
        this.usdm.signalStateCompletion(this.stateName);
      }
    });
  }

  ngOnDestroy(): void {
    this.usdmSub?.unsubscribe();
    this.usdmSub = null;
  }

  extractProperties(): void {
    if (!this.data) {
      console.error('No data available to extract properties from.');
      return;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.http.get(`${environment.osburl}/api/ct/terms/names?page_size=100&codelist_uid=C99077`, {}).subscribe((response: any) => {
      console.log(response)
      if (response) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.studyType = response.items.find((item: any) => item.term_uid === this.data?.study_type)?.sponsor_preferred_name || '';
        console.log(this.studyType);
      }
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.http.get(`${environment.osburl}/api/ct/terms/names?page_size=100&codelist_uid=C66737`, {}).subscribe((response: any) => {
      if (response) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.phaseType = response.items.find((item: any) => item.term_uid === this.data?.phase_type)?.sponsor_preferred_name || '';
      }
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.http.get(`${environment.osburl}/api/ct/terms/names?page_size=100&codelist_uid=C66739`, {}).subscribe((response: any) => {
      if (response) {
        this.trialType = [];
        if (Array.isArray(this.data?.trial_type)) {
          for (const tt of this.data.trial_type) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const name = response.items.find((item: any) => item.term_uid === tt)?.sponsor_preferred_name || '';
            this.trialType.push(name);
          }
        }
      }
    });
  }
}
